import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { Input } from "../../../../../components/inputs/input/input";
import "./onboarding-custom-address-fields.scss";
import CreateReturnMethodScreenStore from "../../../stores/create-return-methods-store";
import { IOption, SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";

interface IProps {
    store: CreateReturnMethodScreenStore;
}
const OnboardingCustomAddressFields:React.FC<IProps> = observer(({ store }) => {
    
    const addressStore = store.returnAddressStore;

    const countriesOptionsList: IOption[] = store.getCountriesOptions();
    const selectedCountry: IOption | undefined = countriesOptionsList.find(country => country.value === addressStore.countryCode);
    const onCountrySelect = (country: IOption) => {
        addressStore.setCountry(country.label);
        addressStore.setCountryCode(country.value as string);
    };

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    //TODO: make sure to validate required fields on client + server
    return (
        <div className="onboarding-custom-address-fields">
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('ADDRESS_NAME', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>
                <Input
                    value={addressStore.name}
                    onChange={(value) => addressStore.setName(value)}
                    required
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('WAREHOUSE_COMPANY_NAME', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>
                <Input
                    value={addressStore.company}
                    onChange={(value) => addressStore.setCompany(value)}
                    required
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('ADDRESS_LINE_1', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>
                <Input
                    value={addressStore.line1}
                    onChange={(value) => addressStore.setLine1(value)}
                    required
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('ADDRESS_LINE_2', scope)}</FontBody2>
                <Input
                    value={addressStore.line2}
                    onChange={(value) => addressStore.setLine2(value)}
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('CITY', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>
                <Input
                    value={addressStore.city}
                    onChange={(value) => addressStore.setCity(value)}
                    required
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('STATE_PROVINCE_REGION', scope)}</FontBody2>
                <Input
                    value={addressStore.state}
                    onChange={(value) => addressStore.setState(value)}
                />
            </div>
            <div className="onboarding-custom-address-field">
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('POSTAL_CODE_ZIP', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>
                <Input
                    value={addressStore.postalCode}
                    onChange={(value) => addressStore.setPostalCode(value)}
                    required
                />
            </div>
            <div className="onboarding-custom-address-field">   
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('COUNTRY', scope)}
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>
                </FontBody2>

                <SelectDropdown
                    value={selectedCountry}
                    options={countriesOptionsList}
                    onChange={(v)=> onCountrySelect(v as IOption)}
                    required
                />
            </div>
        </div>
    );
});

export default OnboardingCustomAddressFields;